import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import cls from 'classnames/bind';

import noop from 'lodash/noop';

import Money from '@ott/money';
import Tooltip from '@ott/tooltip';

import styles from './PriceDate.scss';

const cx = cls.bind(styles);

const LOWEST_POINT_PT = 10;
const getColumnHeight = (minPrice, maxPrice, price) => {
  const proportionOfMaxPrice = (price - minPrice) / (maxPrice - minPrice);

  return price
    ? Math.round(proportionOfMaxPrice * (100 - LOWEST_POINT_PT)) + LOWEST_POINT_PT
    : LOWEST_POINT_PT;
};

const WEEKDAYS_LABELS = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

class PriceDate extends PureComponent {
  static propTypes = {
    date: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)),
    price: PropTypes.number,
    minPrice: PropTypes.number,
    maxPrice: PropTypes.number,
    prepareSearchParams: PropTypes.func,
    onDateClick: PropTypes.func,
    routeFromOtherApp: PropTypes.bool,
  };

  static defaultProps = {
    routeFromOtherApp: false,
    prepareSearchParams: noop,
    onDateClick: noop,
  };

  state = {
    isHovered: false,
  };

  // eslint-disable-next-line no-return-assign
  setColumnRef = (ref) => (this.columnRef = ref);

  getColumnRef = () => this.columnRef;

  renderColumn() {
    const { isHovered } = this.props;
    const { minPrice, maxPrice, price } = this.props;

    return (
      <div className={cx('column')}>
        <div
          className={cx('column-fill', {
            'column-fill--isMinPrice': minPrice === price,
            'column-fill--isUnknown': !price,
            'column-fill--isHovered': isHovered,
          })}
          style={{ height: `${getColumnHeight(minPrice, maxPrice, price)}%` }}
          ref={this.setColumnRef}
        />
      </div>
    );
  }

  handleMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  renderTooltip() {
    const { isHovered } = this.state;
    const { price } = this.props;

    if (!price) {
      return null;
    }

    return (
      <Tooltip
        isVisible={isHovered}
        content={this.wrapInLink(<Money amount={price} />)}
        customTargetRef={this.getColumnRef()}
      />
    );
  }

  renderLabel() {
    const { date } = this.props;

    const weekdayIndex = date.getDay();
    const isHighlighted = [0, 6].includes(weekdayIndex);

    return (
      <div>
        <div
          className={cx('date', {
            'date--isHighlighted': isHighlighted,
          })}
        >
          {date.getDate()}
        </div>

        <div
          className={cx('weekday', {
            'weekday--isHighlighted': isHighlighted,
          })}
        >
          {WEEKDAYS_LABELS[weekdayIndex]}
        </div>
      </div>
    );
  }

  handleClick = (e) => {
    const { price, onDateClick } = this.props;

    if (price) {
      onDateClick();
    } else {
      e.preventDefault();
    }
  };

  wrapInLink(children) {
    const { routeFromOtherApp, date, prepareSearchParams, price } = this.props;

    const preparedParams = prepareSearchParams(date);

    return routeFromOtherApp ? (
      <a
        href={`https://www.onetwotrip.com/ru/tours/search?${preparedParams}`}
        className={cx('link', {
          'link--isInactive': !price,
        })}
        onClick={this.handleClick}
      >
        {children}
      </a>
    ) : (
      <Link
        to={`search?${preparedParams}`}
        className={cx('link', {
          'link--isInactive': !price,
        })}
        onClick={this.handleClick}
      >
        {children}
      </Link>
    );
  }

  render() {
    const { isHovered } = this.state;
    const { price } = this.props;

    return (
      <div
        className={cx('PriceDate', {
          'PriceDate--isHovered': isHovered,
          'PriceDate--isInactive': !price,
        })}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {this.wrapInLink(
          <>
            {this.renderColumn()}
            {this.renderLabel()}
            {this.renderTooltip()}
          </>
        )}
      </div>
    );
  }
}

export default PriceDate;
